import React from 'react';
import { Camera, Database, Zap, TrendingUp, Star, Layers } from 'lucide-react';
import { features } from '../mock';

const iconMap = {
  Camera: Camera,
  Database: Database,
  Zap: Zap,
  TrendingUp: TrendingUp,
  Star: Star,
  Layers: Layers
};

export const Features = () => {
  return (
    <section id="features" className="py-24 bg-black relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-yellow-500 to-transparent"></div>

      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Everything you need to <span className="text-gradient">scale faster</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Snapcom combines AI-powered product recognition with marketplace intelligence to streamline your entire catalogue creation workflow.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className={`feature-card glass rounded-2xl p-8 animate-fade-in-up stagger-${index + 1}`}
              >
                <div className="w-14 h-14 bg-yellow-500/10 rounded-xl flex items-center justify-center mb-6">
                  <IconComponent className="w-7 h-7 text-yellow-500" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">{feature.title}</h3>
                <p className="text-gray-400 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>

        {/* Platform Integration Showcase */}
        <div className="mt-24 glass rounded-3xl p-12">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-white mb-4">Integrated with Leading Marketplaces</h3>
            <p className="text-gray-400 text-lg">Seamlessly connect and publish to your favorite platforms</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-8 bg-black/50 rounded-2xl border border-yellow-500/20 hover:border-yellow-500/50 transition-all duration-300">
              <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 p-3">
                <img 
                  src={require('../assets/images/amazon-logo.png')} 
                  alt="Amazon Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
              <h4 className="text-xl font-bold text-white mb-2">Amazon</h4>
              <p className="text-gray-400">Direct integration with Seller Central</p>
            </div>

            <div className="text-center p-8 bg-black/50 rounded-2xl border border-yellow-500/20 hover:border-yellow-500/50 transition-all duration-300">
              <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 p-3">
                <img 
                  src={require('../assets/images/flipkart-logo.png')} 
                  alt="Flipkart Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
              <h4 className="text-xl font-bold text-white mb-2">Flipkart</h4>
              <p className="text-gray-400">Publish to Seller Hub</p>
            </div>

            <div className="text-center p-8 bg-black/50 rounded-2xl border border-yellow-500/20 hover:border-yellow-500/50 transition-all duration-300">
              <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 p-3">
                <img 
                  src={require('../assets/images/shopify-logo.png')} 
                  alt="Shopify Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
              <h4 className="text-xl font-bold text-white mb-2">Shopify</h4>
              <p className="text-gray-400">Sync with your Shopify store</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};